import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ICustomFieldPromiseLookupService } from "../ICustomFieldPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { CustomFieldLookupService } from "./CustomFieldLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CustomFieldReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.CustomFieldImpl>
  implements ICustomFieldPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.CustomFieldImpl,
      "CustomFieldImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new CustomFieldLookupService(),
    );
  }

  getCustomField(fieldName: string): Promise<CubiqTS.CustomFieldImpl> {
    let request = new UiArguments("getCustomField");
    let arg1 = new FnArg(fieldName, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getCustomFieldOrdinal(field: CubiqTS.CustomFieldImpl): Promise<number> {
    let request = new UiArguments("getCustomFieldOrdinal");
    let arg1 = new FnArg(field, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAllCustomFields(): Promise<CubiqTS.CustomFieldImpl[]> {
    let request = new UiArguments("getAllCustomFields");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  getActiveCustomFields(): Promise<CubiqTS.CustomFieldImpl[]> {
    let request = new UiArguments("getActiveCustomFields");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  isEnabled(fieldName: string): Promise<boolean> {
    let request = new UiArguments("isEnabled");
    let arg1 = new FnArg(fieldName, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
